import axios from 'axios';
import { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { FcGoogle } from 'react-icons/fc'
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify';
import useGoogleAuthRedirect from '../hooks/useGoogleAuthRedirect';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const Signin = () => {
    const { t } = useTranslation()
    useGoogleAuthRedirect()

    const navigate = useNavigate()

    const [errors, setErrors] = useState({});
    const [loadingBtn, setLoadingBtn] = useState(false);
    const [inputValue, setInputValue] = useState({
        email: "",
        password: ""
    });
    const [showPassword, setShowPassword] = useState(false);
    const inputHandler = (e) => {
        const {name, value} = e.target;
        setInputValue({
            ...inputValue,
            [name]: value.trim()
        })
    }

    const validate = () => {
        let errors = {};
        const emailReg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{1,})+$/;

        if (!inputValue.email) {
            errors.email = "Email is required"
        } else if (emailReg.test(inputValue.email) === false) {
            errors.email = "Invalid Email";
        }

        if (!inputValue.password) {
            errors.password = "Password is required"
        }
    
        return errors;
    };

    const signinForm = async (e) => {
        e.preventDefault()

        const formErrors = validate();
        setErrors(formErrors);

        const loginData = {
            email: inputValue.email,
            password: inputValue.password
        }
        
        
        if (Object.keys(formErrors).length === 0) {
            setLoadingBtn(true)
            try {
                const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/login`, loginData)
                const data = await response.data

                if(data.status === 0){
                    toast.error(data.message)
                }

                if(data.status === 1){
                    const userData = {
                        _id: data.result._id,
                        username: data.result._idusername,
                        email: data.result.email,
                        profileImage: data.result.profileImage,
                        type : data.result.type,
                        token: data.token
                    }
                    localStorage.setItem('limitsUser', JSON.stringify(userData))
                    toast.success(data.message)
                    navigate('/')
                }

            } catch (error) {
                console.log('Error:', error)
            } finally {
                setLoadingBtn(false)
            }
        }
    }

    return (
        <>
            <div className='main-content'>
                <div className='padding login-section'>
                    <div className='container'>
                        <div className='login-box mx-auto'>
                            <h4 className='text-center mb-1'>{t('Welcome to LIMITS')}</h4>
                            <p className='text-center mb-5'>{t('Please enter your LOGIN details below.')}</p>
                            
                            <form action="" className='form form1' onSubmit={signinForm}>
                                <div className='mb-3'>
                                    <input type="text" className="form-control" placeholder={t('Email')} name="email" onChange={inputHandler} />
                                    {errors.email && <p className="error-text">{errors.email}</p> }
                                </div>
                                <div className='mb-3'>
                                    <div className="icon-box">
                                        <input type={showPassword ? "text" : "password"}
                                            className="form-control form-control-user"
                                            placeholder={t("Password")}
                                            name="password" onChange={inputHandler}/>
                                        <Link className="icon1"
                                            onClick={() => setShowPassword(!showPassword)}>
                                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                                        </Link>
                                    </div>
                                    {errors.password && <p className="error-text">{errors.password}</p> }
                                </div>

                                <div className='mb-3 mt-4 d-flex align-items-center'>
                                    <div className='w-50'>
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" value="" id="formCheckDefault" />
                                            <label className="form-check-label" htmlFor="formCheckDefault">{t('Remember me')}</label>
                                        </div>
                                    </div>
                                    <div className='w-50 text-end'>
                                        <h6 className='mb-0 text-white'><Link to="/forgot-password" className='link'>{t('Forgot Password?')}</Link></h6>
                                    </div>
                                </div>
                                <div className='mt-3'>
                                    <button className='btn btn1 w-100 mt-4' disabled={loadingBtn}>{t('Login')}</button>
                                </div>
                            </form>

                            <div className='or position-relative text-center my-4 py-2'>
                                <p className='mb-0'>Or</p>
                            </div>

                            <div className='mt-3'>
                                <Link to={`${process.env.REACT_APP_API_URL}/auth/google?type=fan`} target='_parent' type='submit' className='btn btn1 btn-border w-100'><FcGoogle className='align-middle fs-4 me-2' /> <span className='align-middle'>Continue with Google</span></Link>
                            </div>
                            <p className='mb-0 text-center mt-3'>{t('Don’t have an account? Register')} <span className='text-white'><Link to="/user-type" className='link text-decoration-underline fw-medium'>Register</Link></span></p>

                            <p className='mb-0 text-center mt-3'><span className='text-white'><Link to="/" className='link text-decoration-underline fw-medium'>Enter</Link></span></p>
                            
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Signin
